import { render, staticRenderFns } from "./ServiceSummary.vue?vue&type=template&id=264010bc&scoped=true&"
import script from "./ServiceSummary.vue?vue&type=script&lang=js&"
export * from "./ServiceSummary.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSummary.vue?vue&type=style&index=0&id=264010bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264010bc",
  null
  
)

export default component.exports